import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { createDisplayNameForMediaElement } from "../../../utils/getDisplayName";
import { createTestIdForMediaElement } from "../../../utils/getTestId";
import Addon from "../Addon/MediaAddon";

import classes from "./MediaBottomLeftAddon.styl";

const BOTTOM_LEFT_ADDON_DISPLAY_NAME = "BottomLeftAddon";
const BOTTOM_LEFT_ADDON_TEST_ID = createTestIdForMediaElement(
    BOTTOM_LEFT_ADDON_DISPLAY_NAME,
);

/**
 * @deprecated
 * Используйте вместо этого компонента UniBoxAdditional / UniBoxMain
 */
export const BottomLeftAddon = createComponentPreset(
    BOTTOM_LEFT_ADDON_DISPLAY_NAME,
    Addon,
    {
        className: classes.addon,
        "data-tsid": BOTTOM_LEFT_ADDON_TEST_ID,
    },
);

BottomLeftAddon.displayName = createDisplayNameForMediaElement(
    BOTTOM_LEFT_ADDON_DISPLAY_NAME,
);

export default BottomLeftAddon;
